module.exports = __webpack_public_path__ + "img/L_QD.ecb6d660.png";